import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import Typography from "aldoo-ra/Typography"
import { addMember, removeMember, listMembers, listOrgMembersForProject } from "../api"

const ROLE_OPTIONS = [
  { value: "viewer", label: "Viewer" },
  { value: "editor", label: "Editor" },
  { value: "owner", label: "Owner" },
]

const MemberManager = ({ projectId, canManage }) => {
  const [members, setMembers] = useState([])
  const [available, setAvailable] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectedRole, setSelectedRole] = useState(ROLE_OPTIONS[0])
  const [err, setErr] = useState(null)

  const refresh = async () => {
    const [m, a] = await Promise.all([
      listMembers(projectId),
      listOrgMembersForProject(projectId, false),
    ])
    setMembers(m?.members || [])
    setAvailable(a?.members || [])
  }

  useEffect(() => { refresh() }, [projectId])

  const onAdd = async () => {
    setErr(null)
    const userId = selectedUser?.value
    const role = selectedRole?.value
    if (!userId) return setErr("pick_user")
    const r = await addMember({ projectId, userId, role })
    if (r?.error) return setErr(r.error)
    setSelectedUser(null)
    refresh()
  }

  const onRemove = async (userId) => {
    if (!confirm("Remove member?")) return
    const uid = typeof userId === "object" ? (userId?._id || userId?.value) : userId
    await removeMember(projectId, uid)
    refresh()
  }

  const userOptions = available.map((m) => ({
    value: String(m.userId?._id || m.userId),
    label: `${m.userId?.name || "(no name)"} <${m.userId?.email || "?"}>`,
  }))

  return (
    <div className="space-y-3">
      <Typography variant="admin_h3">Members</Typography>

      {canManage && (
        <div className="flex gap-2 items-end max-w-2xl">
          <DropdownSelect label="Org member" value={selectedUser} onChange={(v) => setSelectedUser(v?.[0] || v)} options={userOptions} />
          <DropdownSelect label="Role" value={selectedRole} onChange={(v) => setSelectedRole(v?.[0] || v)} options={ROLE_OPTIONS} />
          <Button onClick={onAdd}>Add</Button>
        </div>
      )}
      {err && <div className="text-red-500 text-sm">Error: {err}</div>}

      <div className="grid gap-2">
        {members.map((m) => (
          <div key={m._id} className="p-2 rounded bg-admin_paper flex justify-between items-center">
            <div>
              <div className="font-medium">{m.userId?.name || "(no name)"} <span className="text-xs text-admin_muted">&lt;{m.userId?.email}&gt;</span></div>
              <div className="text-xs text-admin_muted">role: {m.role}</div>
            </div>
            {canManage && (
              <Button variant="danger" onClick={() => onRemove(m.userId?._id || m.userId)}>Remove</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default MemberManager
